import { NodeExecutionResult } from '@/levity/flows/types';

export enum TestRequestStatus {
  Loading = 'loading',
  Success = 'success',
  Error = 'error',
}

export interface TestRequestResponse {
  status: TestRequestStatus;
  code?: number;
  message?: string;
  data?: string;
}

export interface ConstructNodeTestResponseParams {
  isLoading: boolean;
  error?: { message?: string; data?: unknown };
  stopNodeResult?: NodeExecutionResult;
  lastNodeResults?: NodeExecutionResult[];
}

export type HTTPSApiRequestTypeId = 'post' | 'get' | 'put' | 'patch' | 'delete';

export type HTTPSApiRequestTypeLabel = 'POST' | 'GET' | 'PUT' | 'PATCH' | 'DELETE';

export interface HTTPSApiRequestTypeOptions {
  label: HTTPSApiRequestTypeLabel;
  id: HTTPSApiRequestTypeId;
}

export const HTTPS_ADVANCED_PAYLOAD = 'https-input-advanced-payload';
export interface HttpsAdvancedPayloadInteface {
  [HTTPS_ADVANCED_PAYLOAD]?: string;
}
